import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { DocumentTitle } from '@yakoffice/shared-components';
import { ProjectTheme } from '@yakoffice/project-theme';
import { ProjectTools } from './ProjectTools';

export const ProjectToolsIndex: FC = observer(() => {

    DocumentTitle('Projects - Portal');

    return <ProjectTheme>
        <ProjectTools />
    </ProjectTheme>;
});

export default ProjectToolsIndex;

